<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">อัพโหลดไฟล์เรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ  {{ order_head.order_code }}</b></div>
            <div v-if="order_head.status === 0" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #8CC63E">คำสั่งซื้อใหม่</b></div>
            <div v-if="order_head.status === 1 && order_head.slip_status !== 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #fdac39">ดำเนินการ</b></div>
            <div v-if="order_head.status === 1 && order_head.slip_status === 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: red">ชำระเงินไม่ถูกต้อง</b></div>
            <div v-else-if="order_head.status === 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #8cc63e">เสร็จสิ้น</b></div>
            <div v-else-if="order_head.status === 3" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #eb5c5d">ยกเลิก</b></div>
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลลูกค้า</b></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อลูกค้า : </div>
              <div class="ml-1 mr-3">{{ order_head.name }}</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ที่อยู่จัดส่ง : </div>
              <div class="ml-1 mr-3">{{ order_head.delivery_address }}</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div v-if="order_head.telephone !== null" class="ml-1 mr-3">{{ order_head.telephone }}</div>
              <div v-else class="ml-1 mr-3">-</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>การชำระเงิน</b></div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ชำระผ่าน : </div>
                  <div v-if="order_head.payment_type === 1" class="ml-1 mr-3">โอนเงิน</div>
                  <div v-else-if="order_head.payment_type === 2" class="ml-1 mr-3">ติดเครดิต</div>
                  <div v-else-if="order_head.payment_type === 3" class="ml-1 mr-3">รับสินค้าหน้าร้าน</div>
                </div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ยอดชำระ : </div>
                  <div class="ml-1 mr-3">{{ format_price(order_number) }} บาท</div>
                </div>
                <div class="mt-2" style="color: #C63E3E">
                  <div>หลักฐานการโอนเงินไม่ถูกต้อง</div>
                  <div class="grid_flex">
                    <div class="mr-2">ผู้ตรวจสอบ :</div>
                    <div class="">{{ order_head.user_confirm_name }} {{ order_head.confirm_date }}</div>
                  </div>
                </div>
                <div class="mt-2 display_pc">
                  <v-btn elevation="5" @click="image_addon = true" class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
                  <v-btn elevation="5" @click="cancel_order = true" class="mobile_btn pa-6 ma-1 grad-danger-bg white--text rounded-pill">ยกเลิกคำสั่งซื้อ</v-btn>
                </div>
              </div>
              <div class="mx-auto">
                <v-img v-if="slip_img.slip_picture !== null" class="mx-auto rounded cursor_img" height="160" width="160" max-width="160" :lazy-src="picture_holder" :src="slip_img.slip_picture"></v-img>
                <v-img v-else class="mx-auto rounded cursor_img" height="160" width="160" max-width="160" :lazy-src="picture_holder" :src="picture_holder"></v-img>
              </div>
              <div class="mt-2 display_mobile">
                <v-btn elevation="5" @click="image_addon = true" class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
                <v-btn elevation="5" @click="cancel_order = true" class="mobile_btn pa-6 ma-1 grad-danger-bg white--text rounded-pill">ยกเลิกคำสั่งซื้อ</v-btn>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
              <v-divider/>
              <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage" hide-default-footer mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="border_table">
                      <div class="mx-auto">
                        <v-img class="rounded mx-auto" height="120" width="120" max-width="120" :lazy-src="picture_holder" :src="dataDetail.item.product_picture"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div><b>{{ dataDetail.item.product_name }}</b></div>
                      <div v-if="dataDetail.item.product_list !== null">
                        <div v-for="(data, index) in dataDetail.item.product_list" :key="index">
                          <small class="pl-3">- {{ data.name }} ({{ data.qty }} {{ data.unit_name }})</small>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.cost) }}</td>
                    <td class="border_table text-center">{{ format_number(dataDetail.item.qty) }} {{ dataDetail.item.unit_name }}</td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.total) }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>ค่าจัดส่ง</b></td>
                    <td class="border_table text-center"><b>{{ format_price(order_head.delivery_price) }}</b></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>รวมทั้งหมด</b></td>
                    <td class="border_table text-center"><b>{{ format_price((total + parseFloat(order_head.delivery_price))) }}</b></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </div>
      </div>
      <v-dialog v-model="image_addon" max-width="520">
        <v-card>
          <v-form ref="image" @submit.prevent="upload_addon">
            <div class="d-flex justify-space-between">
              <v-card-title>
                อัพโหลดหลักฐานการโอนเงินเพิ่มเติม
              </v-card-title>
              <v-btn icon class="ma-4" @click="image_addon = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="ml-4">
                  <v-img height="300" max-width="300" v-if="imagePreviewURL === null" :lazy-src="picture_holder" :src="picture_holder" class="preview mx-auto"></v-img>
                  <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :lazy-src="picture_holder" :src="imagePreviewURL" class="preview mx-auto"></v-img>
                </div>
                <v-file-input prepend-icon="mdi-image" color="#86bc3a" accept="image/*" label="อัพโหลด" :rules="[v => !!v || 'กรุณาอัพโหลดไฟล์']" v-model="send_data.addon_file" @change="onFileChange"></v-file-input>
                <div>การอัพโหลดหลักฐานเพิ่มเติมจาก Admin จะทำการยืนยันหลักฐาน อัตโนมัติ</div>
                <div class="mt-6">
                  <v-btn x-large v-if="imagePreviewURL == null" class="rounded-pill white--text grad-grey-bg btn_size" disabled>อัพโหลด</v-btn>
                  <v-btn type="submit" x-large v-if="imagePreviewURL !== null" class="rounded-pill white--text grad-success-bg btn_size">อัพโหลด</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="cancel_order" max-width="700">
        <v-card>
          <v-form ref="cancel" @submit.prevent="save_cancel">
            <div class="d-flex justify-space-between">
              <v-card-title>
                ยกเลิกคำสั่งซื้อ
              </v-card-title>
              <v-btn icon class="ma-4" @click="cancel_order = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="mb-5" style="font-size: 20px">คุณต้องการยกเลิกคำสั่งซื้อของลูกค้าเพราะเหตุใด ?</div>
                <v-text-field color="#86bc3a" label="กรุณากรอกเหตุผลการยกเลิกออเดอร์" v-model="send_data.cancel_note" :rules="[v => !!v || 'กรุณากรอกเหตุผลการยกเลิกออเดอร์']" hide-details="auto" outlined></v-text-field>
              </div>
              <div class="text-center mt-4">
                <v-btn x-large type="submit" class="rounded-pill white--text grad-danger-bg ">ยกเลิกคำสั่งซื้อ</v-btn>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import Swal from "sweetalert2";
import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Pay_incorrect",
  data() {
    return {
      loading_page: false,
      picture_holder: picture_holder,
      overlay: false,
      alert_success: false,
      perPage: -1,
      status: 1,
      order_number: '',
      image_modal: false,
      image_addon: false,
      cancel_order: false,
      imagePreviewURL: null,
      send_data: {
        addon_file: null,
        cancel_note: '',
      },
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '160px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          align: 'center',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      order_head: [],
      slip_img: [],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.send_data.addon_file = null
          })
        } else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.send_data.addon_file = null
          }
        }
      }
      else {
        this.imagePreviewURL = null
        this.send_data.addon_file = null
      }
    },
    upload_addon() {
      if (this.$refs.image.validate()) {
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file = this.send_data.addon_file.name;
        let ext = file.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.send_data.addon_file = null
          })
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('slip_picture', this.send_data.addon_file);
          formData.append('order_id', this.$route.params.id);
          formData.append('user_name', this.$store.state.userDetail.name);
          this.overlay = true
          HTTP.post('sell/attach', formData, config)
              .then((res) => {
            if (res.data.success === true) {
              this.image_addon = false
              this.overlay = false
              // this.send_data.addon_file = null
              // this.alert_success = true
              // setTimeout(() => this.alert_success = false, 2000)
              this.$router.push('/sell/confirmorderdetail/' + this.$route.params.id)
            }
          })
        }
      }
    },
    save_cancel() {
      if (this.$refs.cancel.validate()) {
        Swal.fire({
          title: 'ต้องการยกเลิกคำสั่งซื้อหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.overlay = true
            HTTP.post('sell/cancelorder', {
              order_id: this.$route.params.id,
              note: this.send_data.cancel_note
            }).then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.$router.push('/sell/orderretailcustomers')
              }
            })
          }
          else {
            this.send_data.cancel_note = ''
          }
        })
      }
    },
    async get_data() {
      this.loading_page = true
      await HTTP.post('sell/wrongslip', {
        order_id: this.$route.params.id,
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.order_head = res.data.object.order_head
          if (res.data.object.order_head.total !== null && res.data.object.order_head.total !== 'undefined') {
            this.order_number = res.data.object.order_head.total
          }
          else {
            this.order_number = 0
          }
          res.data.object.order_lists.forEach((data) => {
            this.data_list.push({
              // barcode: data.barcode,
              id: data.id,
              // lot_no: data.lot_no,
              // order_id: data.order_id,
              product_list: data.product_list,
              // product_id: data.product_id,
              product_name: data.product_name,
              product_picture: data.product_picture,
              // promotion_exp_id: data.promotion_exp_id,
              // promotion_main: data.promotion_main,
              // promotion_set_id: data.promotion_set_id,
              unit_name: data.unit_name,
              qty: data.qty,
              cost: data.cost,
              // status: data.status,
              total: data.total,
              // unit_id: data.unit_id,
            })
          })
          this.slip_img = res.data.object.slips[0]
        }
      })
    },
  },
  computed: {
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum,number) => {
        let total_price = number.cost * number.qty
        if (total_price < 0) {
          return sum+(0)
        }
        else {
          return sum+(total_price);
        }
      }, 0)
      return result;
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}
.btn_size {
  width: 100%;
}
.rounded_card {
  border-radius: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
.grid_img {
  display: grid;
  grid-template-columns:70% 30%;
}
.border_table {
  border: #e0e0e0 solid 1px
}
.display_pc {
  display: block;
}
.display_mobile {
  display: none;
}
@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_mx {
    margin: auto;
  }
  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .display_pc {
    display: none;
  }
  .display_mobile {
    display: block;
  }
  .mobile_btn {
    width: 100%;
    margin-left: 0 !important;
  }
}
</style>
